// Legacy URL redirects (from Tilda → new structure)
// Implemented as React Router Navigate (client-side). True HTTP 301s aren't possible
// on Emergent's hosted frontend, but search engines will still follow these on next crawl.
export const REDIRECTS = [
  // Blog
  ["/news", "/blog"],
  ["/news/navitas-champions-2023", "/blog/navitas-champions-2023"],
  ["/news/english-uk-partners", "/blog/english-uk-partners"],
  ["/news/kudi-vstupiti-ielts-5", "/blog/kudi-vstupiti-ielts-5"],
  ["/news/private-school-usa", "/blog/private-school-usa"],

  // Universities and countries
  ["/steps", "/university/steps"],
  ["/university-nl", "/university/netherlands"],
  ["/university-uk", "/university/united-kingdom"],
  ["/university-usa", "/university/usa"],
  ["/usa", "/countries/usa"],
  ["/boarding-schools-usa", "/boarding-schools/usa"],

  // Netherlands
  ["/universityofamsterdam-ru", "/university/netherlands/amsterdam"],
  ["/universityoftwente-ru", "/university/netherlands/twente"],
  ["/maastrichtuniversity-ru", "/university/netherlands/maastricht-university"],

  // United Kingdom
  ["/queenmaryuniversityoflondon-ru", "/university/united-kingdom/queen-mary-university-of-london"],
  ["/bournemouthuniversity-ru", "/university/united-kingdom/bournemouth"],
  ["/yorkuniversity-ru", "/university/united-kingdom/york"],
  ["/cityuniversityoflondon-ru", "/university/united-kingdom/city-university-of-london"],
  ["/universityofwestminster-ru", "/university/united-kingdom/westminster"],
  ["/universityofbrighton-ru", "/university/united-kingdom/brighton"],

  // Webinar
  ["/webinar09/06/2026/vstup-ua-2026", "/webinar/usa"],

  // Services
  ["/services/tproduct/1025020666-254965544842-letnie-yazikovie-lagerya", "/services"],

  // Consultations
  ["/tproduct/1022176536-400856881012-konsultatsiya-s-alinoi-grigoryan", "/prospectives-alina"],
  ["/tproduct/1022176536-400856881012-konsultatsiya-s-obrazovatelnim-ekspertom", "/prospectives-alina"],
  ["/tproduct/1022176536-651671775092-konsultatsiya-po-obrazovaniyu-za-rubezho", "/prospectives"],
  ["/tproduct/1022176536-651671775092-konsultatsiya-s-ekspertom-studygri", "/prospectives"],
  ["/tproduct/1022176536-807139743922-besplatnaya-konsultatsiya", "/prospectives"],
  ["/tproduct/1022176536-807139743922-besplatnaya-konsultatsiya-po-obrazovaniy", "/prospectives"],
  ["/tproduct/279259939752-konsultatsya-z-osvtnm-ekspertom-alnoyu-g", "/prospectives-alina"],

  // Boarding schools
  ["/tproduct/1025037511-384658387662-obuchenie-v-shkolah-pansionah-za-granits", "/boarding-schools/united-kingdom"],
  ["/tproduct/1025037511-384658387662-shkoli-pansioni-za-granitsei-dlya-detei", "/boarding-schools/united-kingdom"],
  ["/tproduct/957404691462-navchannya-v-shkol-panson-dlya-dtei-7-18", "/boarding-schools/united-kingdom"],

  // Foundation / Bachelor / Master programmes
  ["/tproduct/1035158041-332508967572-foundation", "/services"],
  ["/tproduct/1035158041-332508967572-postuplenie-na-foundation-podgotovitelni", "/services"],
  ["/tproduct/1035158041-659925861432-magistratura-graduate-degree", "/services"],
  ["/tproduct/1035158041-659925861432-postuplenie-na-magistraturu-graduate-deg", "/services"],
  ["/tproduct/1035158041-745553539432-bakalavriat-undergraduate-degree", "/services"],
  ["/tproduct/1035158041-745553539432-postuplenie-na-bakalavriat-undergraduate", "/services"],
  ["/tproduct/234388681902-vstup-na-bakalavrat-undergraduate-degree", "/services"],
  ["/tproduct/482109170512-navchannya-v-ltnh-movnih-taborah-za-kord", "/services"],
  ["/tproduct/676756808552-vstup-na-magstraturu-graduate-degree-onc", "/services"],
];
